module.exports = __webpack_public_path__ + "static/dms-home-destacado-d74dcba62a226ea016ed62b609a31e45.svg";